/* eslint-disable react/prop-types */
import React, { memo, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import dynamic from 'next/dynamic';
import useScreenSize from '../../../hooks/useScreenSize';
import {
  ItemCreationContentContainer,
  ItemCreationLayoutWrapper,
  ItemCreationContentTitle,
  LeftActionBlock,
  headerStyles
} from './styled';
import { BackButtonIconEnum } from '../../ui/PageHeader/types';
import { ItemCreationLayoutProps } from './types';

const PageHeader = dynamic(
  () => import('../../ui/PageHeader').then(mod => mod.PageHeader),
  { ssr: false }
);

const MemoPageHeader = memo(PageHeader);

export const ItemCreationLayoutComponent: React.FC<ItemCreationLayoutProps> = ({
  cypress,
  children,
  modalHeaderRightBlock,
  contentCypress,
  header,
  onClose,
  isFormStep = false,
  leftModalBlock,
  isModalHeaderHidden = false,
  isEditPage = false
}) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    } else {
      router.back();
    }
  }, [onClose, router]);

  return (
    <ItemCreationLayoutWrapper $isFormStep={isFormStep}>
      {isSmall && !isModalHeaderHidden && (
        <MemoPageHeader
          icon={BackButtonIconEnum.Close}
          onClick={handleClose}
          titleCypress={`${cypress}--title`}
          title={header || t('new_ad.title')}
          backButtonCypress={`${cypress}--header-btn-close`}
          rightBlock={modalHeaderRightBlock}
          headerTag="h5_new"
          styles={headerStyles}
        />
      )}

      {leftModalBlock && !isSmall && (
        <LeftActionBlock>{leftModalBlock}</LeftActionBlock>
      )}
      <ItemCreationContentContainer
        $isFormStep={isFormStep}
        data-cy={contentCypress}
        $isEditPage={isEditPage}
      >
        <ItemCreationContentTitle tag="h2_new">
          {header || t('new_ad.title')}
        </ItemCreationContentTitle>
        {children}
      </ItemCreationContentContainer>
    </ItemCreationLayoutWrapper>
  );
};

export const ItemCreationLayout = memo(ItemCreationLayoutComponent);
